// import { searchResultsQueryKey } from "~/hooks/useSearchResults.ts";
// import { api } from "~/common/utils/trpc.js";
// import type { AppRouter } from "@acme/backend/trpc";
import { useQueryClient } from "@tanstack/react-query";
// import type { inferProcedureInput } from "@trpc/server";
import { createContext, useMemo } from "react";
import type { FunctionComponent, ReactNode } from "react";

//type InvalidateTestDbTestOptions = inferProcedureInput<AppRouter["test"]["dbTest"]>;
//type InvalidateTestTrpcTestOptions = inferProcedureInput<AppRouter["test"]["trpcTest"]>;

interface InvalidateQueries
{
  //invalidateTestDbTestOptions: (options?: InvalidateTestDbTestOptions) => Promise<void>;
  //invalidateTestTrpcTestOptions: (options?: InvalidateTestTrpcTestOptions) => Promise<void>;
}

export const InvalidateQueriesContext = createContext<InvalidateQueries | null>(null);

interface InvalidateQueriesProviderProps
{
  readonly children: ReactNode;
}

export const InvalidateQueriesProvider: FunctionComponent<InvalidateQueriesProviderProps> = ({ children }) =>
{
  const queryClient = useQueryClient();

  const invalidateQueries: InvalidateQueries = useMemo(
    () => ({
      //   invalidateTestDbTestOptions: async (options) =>
      //     queryClient.invalidateQueries({
      //       queryKey: api.test.dbTest.queryKey(options),
      //     }),
      //   invalidateTestTrpcTestOptions: async (options) =>
      //     queryClient.invalidateQueries({
      //       queryKey: api.test.trpcTest.queryKey(options),
      //     }),
      // invalidateSearchResults: async (value) =>
      // {
      //   const queryKey = [searchResultsQueryKey];
      //   if (value)
      //   {
      //     queryKey.push(value);
      //   }
      //   await queryClient.invalidateQueries({ queryKey });
      // },
    }),
    [queryClient]
  );

  return <InvalidateQueriesContext.Provider value={invalidateQueries}>{children}</InvalidateQueriesContext.Provider>;
};
